(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  // 推荐产品动态加载
  var loadProductRecommendationsIntoSection = function() {
    document.querySelectorAll(".product-recommendations").forEach(function(productRecommendationsSection) {
      var productId = productRecommendationsSection.dataset.productId;
      var limit = productRecommendationsSection.dataset.limit;
      var sectionId = productRecommendationsSection.dataset.sectionId;
      if (!productId || !sectionId) return;

      var requestUrl = "/recommendations/products?section_id=" + sectionId + "&limit=" + limit + "&product_id=" + productId;
      var request = new XMLHttpRequest();
      request.open("GET", requestUrl);
      request.onload = function() {
        if (request.status >= 200 && request.status < 300) {
          var container = document.createElement("div");
          container.innerHTML = request.response;
          var newSection = container.querySelector(".product-recommendations");
          if (newSection) {
            productRecommendationsSection.innerHTML = newSection.innerHTML;
            // Ajax 加载后重新初始化 Swiper 和心愿单
            initSwiperAndWishlist(sectionId);
            setTimeout(function() {
              myAppJavaScript_cfp(jQuery191);
            }, 1000);
          }
        }
      };
      request.send();
      
    });
  };

  

  // 初始化 Swiper 和心愿单功能
  function initSwiperAndWishlist(sectionId) {
    if (typeof Swiper === 'undefined') {
      console.error('Swiper library is not loaded');
      return;
    }
    // Swiper 初始化
    var swiper = new Swiper('#productSwiper-' + sectionId, {
      slidesPerView: 5,
      spaceBetween: 20,
      autoHeight: true,
      wrapperClass: 'swiper-wrapper-' + sectionId,
      slideClass: 'swiper-slide-' + sectionId,
      breakpoints: {
        320: { slidesPerView: 1.5, spaceBetween: 20 },
        600: { slidesPerView: 2, spaceBetween: 20 },
        900: { slidesPerView: 3, spaceBetween: 20 },
        1200: { slidesPerView: 4, spaceBetween: 20 },
        1400: { slidesPerView: 5, spaceBetween: 20 }
      },
      navigation: {
        nextEl: '.swiper-button-next-' + sectionId,
        prevEl: '.swiper-button-prev-' + sectionId,
      },
      on: {
        init: function() {
          updateProgressBar(sectionId, this);
        },
        slideChange: function() {
          updateProgressBar(sectionId, this);
        }
      }
    });

    // 进度条
    function updateProgressBar(sectionId, swiperInstance) {
      var progressBar = document.getElementById('progressBar-' + sectionId);
      if (!progressBar) return;
      var totalSlides = swiperInstance.slides.length;
      var visibleSlides = swiperInstance.params.slidesPerView;
      var currentIndex = swiperInstance.activeIndex;
      var maxIndex = totalSlides - visibleSlides;
      var progress = maxIndex > 0 ? (currentIndex / maxIndex) * 100 : 100;
      var progressWidth = (visibleSlides / totalSlides) * 100;
      var progressPosition = (currentIndex / totalSlides) * 100;
      progressBar.style.width = progressWidth + '%';
      progressBar.style.transform = `translateX(${progressPosition / (progressWidth / 100)}%)`;
    }

    window.addEventListener('resize', function() {
      setTimeout(() => {
        updateProgressBar(sectionId, swiper);
      }, 100);
    });

    // Add to Quote hover button
    document.querySelectorAll('.product-atc-hover-' + sectionId).forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const card = this.closest('.product-card-' + sectionId);
        if (!card) return;
        const cfpBtn = card.querySelector('.cfp_custom_position a, .cfp_custom_position button');
        if (cfpBtn) cfpBtn.click();
      });
    });
  }

  // 监听 theme editor section 重新加载
  document.addEventListener("shopify:section:load", function(event) {
    var section = event.target.querySelector(".product-recommendations");
    if (section) {
      loadProductRecommendationsIntoSection();
    }
  });

  // 页面加载时拉取推荐产品并初始化 Swiper/心愿单
  document.addEventListener("DOMContentLoaded", function() {
    loadProductRecommendationsIntoSection();
    // 如果页面初始就有内容，也初始化一次
    document.querySelectorAll(".product-recommendations").forEach(function(section) {
      var sectionId = section.dataset.sectionId;
      if (sectionId) {
        initSwiperAndWishlist(sectionId);
      }
    });
  });
  
  } catch(e) { console.error(e); }
})();
})();
